import { useState, useCallback } from "react";
import { Button, Stack, Typography } from "@mui/material";
import { useStyles } from "./styles";

import { useMutation } from "react-query";
import { updateTemplate, saveTemplate } from "../../services/templates";
import { SaveDialog } from "./New";
import { useToast } from "../../hooks/useToast";
import { queryClient } from "../../services/queryClient";
import TabPanel from "../../components/TabPanel";
import { ListTemplates } from "./List";
import { Editor } from "./Editor";

export function EmailTemplates() {
  const styles = useStyles();
  const toast = useToast();

  const [activeView, setActiveView] = useState(0);
  const [templateHtml, setTemplateHtml] = useState<string>();
  const [templateDesign, setTemplateDesign] = useState<any>({});
  const [selectedTemplate, setSelectedTemplate] = useState({
    formatedData: {
      idTemplate: undefined,
      templateName: undefined,
      templateLink: undefined,
      templateType: undefined,
      templateSelecionado: undefined,
      exportTemplate: {},
      jsonTemplate: null,
    },
    trueData: null,
  });
  const [showSaveDialog, setShowSaveDialog] = useState(false);

  const newUpdateTemplate = useMutation(
    async (param1: any) => {
      toast.show("Salvando...", { severity: "info" });

      const response = await updateTemplate(param1);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Sucesso ao editar template!", { severity: "success" });
        queryClient.invalidateQueries("templates component");
      },
      onError: () => {
        toast.show("Erro ao editar template!", {
          severity: "error",
        });
      },
    }
  );

  const newSaveTemplate = useMutation(
    async (param1: any) => {
      toast.show("Salvando...", { severity: "info" });

      const response = await saveTemplate(param1);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Sucesso ao salvar template!", { severity: "success" });
        queryClient.invalidateQueries("templates component");
      },
      onError: () => {
        toast.show("Erro ao salvar template!", {
          severity: "error",
        });
      },
    }
  );

  const salvarTemplate = async (callback?) => {
    const objTemplate = {
      htmlTemplate: templateHtml,
      jsonTemplate: templateDesign,
      nomeTemplate: selectedTemplate.formatedData.templateName,
      tipoTemplate: selectedTemplate.formatedData.templateType.label || "EMAIL",
      arquivoTemplate:
        selectedTemplate.formatedData.templateType.value || "html",
    };

    await newSaveTemplate.mutateAsync(objTemplate);

    callback && callback();
  };

  const editarTemplate = async () => {
    const objTemplate = {
      id_template: selectedTemplate.trueData.id_template,
      nomeTemplate: selectedTemplate.formatedData.templateName,
      htmlTemplate: templateHtml,
      jsonTemplate: templateDesign,
      tipoTemplate: selectedTemplate.formatedData.templateType.label || "EMAIL",
      arquivoTemplate:
        selectedTemplate.formatedData.templateType.value || "html",
    };

    await newUpdateTemplate.mutateAsync(objTemplate);
  };

  const handleChangeView = useCallback((view: number) => {
    setActiveView(view);
  }, []);

  const handleSelectTemplate = useCallback(
    (data: any) => {
      setSelectedTemplate(data);
      handleChangeView(0);
    },
    [handleChangeView]
  );

  const handleChangeTemplate = useCallback((design: any, html: string) => {
    setTemplateHtml(html);
    setTemplateDesign(design);
  }, []);

  return (
    <>
      <div data-testid="template-content-name" className={styles.root}>
        <Typography data-testid="template-name" variant="h4">
          Templates de Email
        </Typography>
      </div>
      <Stack
        data-testid="template-content-actions"
        direction="row"
        justifyContent="space-between"
      >
        <Stack
          data-testid="template-content-actions-views"
          direction="row"
          spacing={2}
          className={styles.rootActions}
        >
          <Button
            data-testid="template-content-actions-view-new-template"
            variant={activeView === 0 ? "contained" : "outlined"}
            onClick={() => handleChangeView(0)}
          >
            Criar Templates
          </Button>
          <Button
            data-testid="template-content-actions-view-list-templates"
            variant={activeView === 1 ? "contained" : "outlined"}
            onClick={() => handleChangeView(1)}
          >
            Lista de Templates
          </Button>
        </Stack>
        <Stack
          data-testid="template-content-actions"
          direction="row"
          spacing={2}
          className={styles.rootActions}
        >
          <Button
            data-testid="template-content-btn-save-copy"
            variant="outlined"
            disabled={!selectedTemplate?.trueData}
            onClick={() => setShowSaveDialog(true)}
          >
            Salvar cópia
          </Button>
          <Button
            data-testid="template-content-btn-save"
            variant="outlined"
            onClick={() =>
              selectedTemplate?.trueData
                ? editarTemplate()
                : setShowSaveDialog(true)
            }
          >
            Salvar template
          </Button>
        </Stack>
      </Stack>
      <TabPanel index={0} value={activeView}>
        <Editor onChange={handleChangeTemplate} template={selectedTemplate} />
      </TabPanel>
      <TabPanel index={1} value={activeView}>
        <ListTemplates onSelect={handleSelectTemplate} />
      </TabPanel>

      {showSaveDialog && (
        <SaveDialog
          open={showSaveDialog}
          template={selectedTemplate.formatedData}
          onSave={() => {
            setShowSaveDialog(false);
            salvarTemplate();
          }}
          onEdit={() => {
            setShowSaveDialog(false);
            editarTemplate();
          }}
          onChange={(state, value) =>
            setSelectedTemplate((prev) => ({
              ...prev,
              formatedData: {
                ...prev.formatedData,
                [state]: value,
              },
            }))
          }
          onClose={() => setShowSaveDialog(false)}
        />
      )}
    </>
  );
}
